<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 650 512"
  >
    <path
      fill="#dbe8ec"
      d="M596.45208,244.76815V226.577a13.07946,13.07946,0,0,0-13.07946-13.07946h-46.166a13.07945,13.07945,0,0,1-13.07945-13.07945V182.22692a13.07945,13.07945,0,0,1,13.07945-13.07945h1.45764A13.07945,13.07945,0,0,0,551.7437,156.068V137.87685a13.07945,13.07945,0,0,0-13.07945-13.07945H166.75711a13.07945,13.07945,0,0,0-13.07946,13.07945V156.068a13.07945,13.07945,0,0,0,13.07946,13.07945h0a13.07945,13.07945,0,0,1,13.07945,13.07945v18.19116a13.07945,13.07945,0,0,1-13.07945,13.07945H116.17772A13.07945,13.07945,0,0,0,103.09827,226.577v18.19116a13.07945,13.07945,0,0,0,13.07945,13.07945h19.84659a13.07945,13.07945,0,0,1,13.07945,13.07945V289.1183a13.07945,13.07945,0,0,1-13.07945,13.07945h-.048a13.07945,13.07945,0,0,0-13.07946,13.07945v18.19108a13.07945,13.07945,0,0,0,13.07946,13.07945h2.87138a13.07945,13.07945,0,0,1,13.07945,13.07945v18.19125a13.07945,13.07945,0,0,1-13.07945,13.07945H91.72322a13.07945,13.07945,0,0,0-13.07945,13.07945V422.1685A13.07945,13.07945,0,0,0,91.72322,435.248h453.963a13.07945,13.07945,0,0,0,13.07945-13.07945V403.97733a13.07945,13.07945,0,0,0-13.07945-13.07945H534.34572a13.07945,13.07945,0,0,1-13.07946-13.07945V359.62718a13.07945,13.07945,0,0,1,13.07946-13.07945h26.73985A13.07945,13.07945,0,0,0,574.165,333.46828V315.2772a13.07945,13.07945,0,0,0-13.07945-13.07945h-8.11162A13.07945,13.07945,0,0,1,539.8945,289.1183V270.92705a13.07945,13.07945,0,0,1,13.07945-13.07945h30.39867A13.07945,13.07945,0,0,0,596.45208,244.76815Z"
    />
    <path
      fill="#b9d4db"
      d="M426.33375,137.87353a29.54017,29.54017,0,0,1-29.51385,29.5269H286.53459a22.75616,22.75616,0,0,1-4.83773-44.99256,26.2542,26.2542,0,0,1,26.16185-24.52338,25.48181,25.48181,0,0,1,7.93618,1.2679,41.42545,41.42545,0,0,1,77.11377,9.49993,29.47753,29.47753,0,0,1,33.42509,29.22121Zm0,0"
    />
    <path
      fill="#e59413"
      d="M436.63273,374.64289l-214.7486-.35354a12.98768,12.98768,0,0,1-12.99869-12.97666l-25.76523-140.081A12.98768,12.98768,0,0,1,196.09687,208.233H315.13876c.59774-.0005,29.51124,36.75919,30.08761,36.83689,8.03129,1.0826,129.33906,23.82087,126.1699,31.27943L449.60939,361.6442A12.98769,12.98769,0,0,1,436.63273,374.64289Z"
    />
    <path
      fill="#409cb5"
      d="M198.14953 332.52963h61.84313V268.13994H188.923a10.25857 10.25857 0 00-10.039 12.3698l9.22651 43.87254A10.25858 10.25858 0 00198.14953 332.52963zM283.36412 237.37332a164.72184 164.72184 0 013.21728-34.355A132.82562 132.82562 0 01297.59849 170.241a101.76807 101.76807 0 018.99268-14.88257 75.39454 75.39454 0 0111.793-12.877 58.27987 58.27987 0 0114.86817-9.37158 45.26931 45.26931 0 0134.78613-.34741 58.87842 58.87842 0 0115.2085 9.14478 76.408 76.408 0 0112.21045 12.77563 103.13394 103.13394 0 019.42871 14.87646A134.72837 134.72837 0 01416.767 202.54544a167.35745 167.35745 0 014.01758 34.82788h-6a161.7466 161.7466 0 00-3.1504-33.72461 129.86941 129.86941 0 00-10.75634-32.04419 98.81841 98.81841 0 00-8.71875-14.44458 72.48477 72.48477 0 00-11.32422-12.38159 55.32645 55.32645 0 00-14.07178-8.89087 42.27027 42.27027 0 00-32.519-.34741 55.86 55.86 0 00-14.4126 8.66406 73.37805 73.37805 0 00-11.74121 12.28027 100.062 100.062 0 00-9.15527 14.43824 131.70045 131.70045 0 00-11.62012 32.25341A164.30693 164.30693 0 00283.36412 237.37332z"
    />
    <path
      fill="#f9ae2b"
      d="M443.59485,374.45479l-221.82951.18809a12.98768,12.98768,0,0,1-12.99868-12.97666l35.77376-147.11916a12.98768,12.98768,0,0,1,12.97666-12.99869l73.77255-.06255a12.98767,12.98767,0,0,1,10.6346,5.51645L354.3264,239.2244a12.98767,12.98767,0,0,0,10.63461,5.51645l114.42229-.08832A12.98769,12.98769,0,0,1,492.382,257.62919L456.57151,361.4561A12.98768,12.98768,0,0,1,443.59485,374.45479Z"
    />
    <line
      x1="274.279"
      x2="444.404"
      y1="272.241"
      y2="272.241"
      fill="none"
      stroke="#ee781d"
      stroke-miterlimit="10"
      stroke-width="5"
    />
    <line
      x1="259.993"
      x2="430.118"
      y1="305.988"
      y2="305.988"
      fill="none"
      stroke="#ee781d"
      stroke-miterlimit="10"
      stroke-width="5"
    />
    <line
      x1="242.226"
      x2="412.351"
      y1="340.905"
      y2="340.905"
      fill="none"
      stroke="#ee781d"
      stroke-miterlimit="10"
      stroke-width="5"
    />
    <path
      fill="#409cb5"
      d="M375.48255,308.94887,418.192,272.8522a2.56465,2.56465,0,0,1,4.22014,1.95877v4.682a2.56464,2.56464,0,0,0,2.56464,2.56464h59.06339l49.85671-6.95885v71.348H424.97674a2.56464,2.56464,0,0,0-2.56464,2.56464v3.48071a2.56465,2.56465,0,0,1-4.35377,1.83752l-42.70941-41.58446A2.56465,2.56465,0,0,1,375.48255,308.94887Z"
    />
    <path
      fill="#3086a3"
      d="M484.04007,282.05741h42.898a6.95873,6.95873,0,0,0,6.95873-6.95873v0a6.95873,6.95873,0,0,0-6.95873-6.95873H488.75677Z"
    />
    <path
      fill="#409cb5"
      d="M432.80366,223.47575a40.44393,40.44393,0,0,1-2.71729,4.792c-.9873,1.51587-2.04053,2.96607-3.12988,4.37964-1.09131,1.41187-2.23487,2.77173-3.40967,4.09986-1.17529,1.32788-2.39844,2.60791-3.64111,3.86816l-2.11621,2.14551L415.664,240.6154c-1.24561-1.25732-2.46875-2.53735-3.646-3.86328-1.17285-1.33032-2.32226-2.68433-3.41064-4.09888-1.09034-1.41284-2.14307-2.86328-3.1294-4.38013a40.06672,40.06672,0,0,1-2.7124-4.79736,40.01165,40.01165,0,0,1,4.79736,2.71216c1.51709.98633,2.96729,2.03906,4.38037,3.12939,1.41456,1.08838,2.76856,2.2378,4.09864,3.41065,1.32617,1.17724,2.606,2.40039,3.86328,3.646H415.664c1.26025-1.24291,2.54052-2.46606,3.86816-3.64111,1.32813-1.175,2.688-2.3186,4.09961-3.40991,1.41406-1.08936,2.86377-2.14233,4.37988-3.12964A40.43085,40.43085,0,0,1,432.80366,223.47575Z"
    />
    <path
      fill="#b9d4db"
      d="M294.20792,167.40043h15.12s52.74-25.71775,33.48-42.45775S294.20792,167.40043,294.20792,167.40043Z"
    />
    <path
      fill="none"
      stroke="#409cb5"
      stroke-miterlimit="10"
      stroke-width="2"
      d="M256.58792 137.87353H217.76665a9 9 0 00-9 9v11.52691a9 9 0 01-9 9H131.66791a9 9 0 00-9 9v10.82226a9 9 0 01-9 9h-17.28a9 9 0 01-9-9v-23.04a9 9 0 00-9-9h-15.84a9 9 0 00-9 9V206.26a9 9 0 009 9h0a9 9 0 019 9v22.56a9 9 0 009 9h9.36a9 9 0 019 9v1.27873a9 9 0 009 9h57.24M426.33375 137.87353h32.9427a7.91147 7.91147 0 007.91147-7.91147V84.66352a7.91148 7.91148 0 017.91147-7.91147h29.53706a7.91147 7.91147 0 017.91147 7.91147v85.239a7.91148 7.91148 0 007.91147 7.91147h15.49706a7.91146 7.91146 0 017.91147 7.91146v7.84891a7.91146 7.91146 0 01-7.91147 7.91147H484.81939a7.91148 7.91148 0 00-7.91147 7.91147v4.06787a7.91148 7.91148 0 007.91147 7.91147h86.77706a7.91146 7.91146 0 017.91147 7.91146v35.04185a7.91147 7.91147 0 01-7.91147 7.91147H560.41939a7.91147 7.91147 0 00-7.91147 7.91146v0a7.91148 7.91148 0 007.91147 7.91147h20.89706a7.91146 7.91146 0 017.91147 7.91147v19.41539a7.91147 7.91147 0 01-7.91147 7.91147H533.89684"
    />
    <circle cx="95.22" cy="354.65" r="17.074" fill="#b9d4db" />
    <circle cx="110.053" cy="381.889" r="5.469" fill="#b9d4db" />
    <circle cx="141.351" cy="374.105" r="10.826" fill="#b9d4db" />
    <circle cx="133.456" cy="342.369" r="9.839" fill="#b9d4db" />
    <circle cx="535.448" cy="125.787" r="17.074" fill="#b9d4db" />
    <circle cx="529.983" cy="156.318" r="5.469" fill="#b9d4db" />
    <circle cx="559.271" cy="169.822" r="10.826" fill="#b9d4db" />
    <circle cx="572.962" cy="140.122" r="9.839" fill="#b9d4db" />
    <circle cx="498.263" cy="379.979" r="17.074" fill="#b9d4db" />
    <circle cx="481.188" cy="415.589" r="5.469" fill="#b9d4db" />
    <circle cx="515.338" cy="421.058" r="10.826" fill="#b9d4db" />
    <circle cx="531.081" cy="389.818" r="9.839" fill="#b9d4db" />
    <path
      fill="none"
      stroke="#409cb5"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="3"
      d="M93.46105 131.1824c4.14748 0 4.14748 6 8.295 6 4.14616 0 4.14616-6 8.29232-6 4.149 0 4.149 6 8.298 6s4.149-6 8.298-6M93.46105 141.68051c4.14748 0 4.14748 6 8.295 6 4.14616 0 4.14616-6 8.29232-6 4.149 0 4.149 6 8.298 6s4.149-6 8.298-6M93.46105 152.17862c4.14748 0 4.14748 6 8.295 6 4.14616 0 4.14616-6 8.29232-6 4.149 0 4.149 6 8.298 6s4.149-6 8.298-6M556.37068 337.5755c4.14747 0 4.14747 6 8.29494 6 4.14616 0 4.14616-6 8.29232-6 4.149 0 4.149 6 8.298 6s4.149-6 8.298-6M556.37068 348.07361c4.14747 0 4.14747 6 8.29494 6 4.14616 0 4.14616-6 8.29232-6 4.149 0 4.149 6 8.298 6s4.149-6 8.298-6M556.37068 358.57172c4.14747 0 4.14747 6 8.29494 6 4.14616 0 4.14616-6 8.29232-6 4.149 0 4.149 6 8.298 6s4.149-6 8.298-6M239.99627 391.73489c4.14748 0 4.14748 6 8.295 6 4.14616 0 4.14616-6 8.29232-6 4.149 0 4.149 6 8.298 6s4.149-6 8.298-6M239.99627 402.233c4.14748 0 4.14748 6 8.295 6 4.14616 0 4.14616-6 8.29232-6 4.149 0 4.149 6 8.298 6s4.149-6 8.298-6M239.99627 412.7311c4.14748 0 4.14748 6 8.295 6 4.14616 0 4.14616-6 8.29232-6 4.149 0 4.149 6 8.298 6s4.149-6 8.298-6"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useNamespace } from '@bigin/hooks'

let id = 0
export default defineComponent({
  name: 'ImgEmpty',
  setup() {
    const ns = useNamespace('empty')
    return {
      ns,
      id: ++id,
    }
  },
})
</script>
